import React from 'react';
import { getParamFromString } from '@tcp/core/src/utils';

function UseLoginSectionForm(props, routerPush, lblLoginForgotPwdCta) {
  const {
    isResetPassCodeValidationEnabled,
    resetForm,
    resetLoginState,
    closeModal,
    closeOverlay,
    trackAnalyticsClick,
    showForgotPasswordForm,
    handleSubmit,
    onGenerateOTP,
    existingUserResponse,
    pristine,
    isLoading,
    isV2Flow,
  } = props;
  const [isSmsConsentChecked, setIsSmsConsentChecked] = React.useState(false);
  const [selectedLoginOption, setLoginOption] = React.useState('password');
  const isSMSOpted = selectedLoginOption === 'sms';
  const handleTermsChange = () => {
    setIsSmsConsentChecked(!isSmsConsentChecked);
  };

  const showForgotPassword = (e) => {
    e.preventDefault();
    trackAnalyticsClick({
      metric33: '1',
      eVar150: lblLoginForgotPwdCta,
      customEvents: ['event33'],
    });
    resetForm();
    resetLoginState();
    if (isResetPassCodeValidationEnabled) {
      closeModal();
      closeOverlay();
      const { url } = window?.history?.state || {};
      const successtarget = (url && getParamFromString('successtarget', url)) || '';
      const successTargetParam = successtarget ? `&successtarget=${successtarget}` : '';
      if (isV2Flow) {
        routerPush(
          `/change-password?page=reset&fromPage=checkout`,
          `/change-password?page=reset&fromPage=checkout`
        );
      } else {
        routerPush(
          `/change-password?page=reset${successTargetParam}`,
          `/change-password?page=reset${successTargetParam}`
        );
      }
    } else {
      showForgotPasswordForm();
    }
  };
  const shouldLoginButtonDisabled = () => {
    return !((isSMSOpted && isSmsConsentChecked) || !isSMSOpted) || pristine || isLoading;
  };
  const isLoginBtnDisbaled = () => {
    return pristine || isLoading;
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (isSMSOpted) {
      onGenerateOTP({ otpChannel: 'sms' });
    } else {
      handleSubmit();
    }
  };
  const submitForm2 = (e, type) => {
    e.preventDefault();
    setTimeout(() => {
      if (type === 'sms') {
        onGenerateOTP({ otpChannel: 'sms' });
      } else {
        handleSubmit();
      }
    }, 0);
  };

  const sendCodeViaEmail = (e) => {
    e.preventDefault();
    onGenerateOTP({ otpChannel: 'email' });
  };

  const { emailAddress } = existingUserResponse || {};
  return {
    submitForm,
    emailAddress,
    selectedLoginOption,
    setLoginOption,
    showForgotPassword,
    isSMSOpted,
    handleTermsChange,
    sendCodeViaEmail,
    shouldLoginButtonDisabled,
    isLoginBtnDisbaled,
    submitForm2,
  };
}

export default UseLoginSectionForm;
